import axios from "axios";
import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AlertComponent from "../../components/AlertComponent";
import { Context } from "../../Reducers/Store";
import { apiUrl, getPayload } from "../../services/apiConfig";
import { errorMessage } from "../../utils/formatters";

export default function PrimeiroAdmin() {
  const navigate = useNavigate();
  const [, dispatch] = useContext(Context);
  const [form, setForm] = useState({ nome: "", login: "", senha: "" });

  const setField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post(apiUrl("/auth/primeiro-admin"), form)
      .then((response) => {
        dispatch({ type: "SET_LOGGED", payload: getPayload(response) });
        AlertComponent("Pronto", "Administrador criado com sucesso.");
        navigate("/dashboard", { replace: true });
      })
      .catch((error) => {
        AlertComponent("Erro", errorMessage(error, "Não foi possível criar o primeiro administrador."), { icon: "error" });
      });
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center px-4 py-10"
      style={{ background: "linear-gradient(160deg, #1e1b4b 0%, #3b0764 100%)" }}
    >
      <div className="w-full max-w-md">
        <div className="mb-8 flex items-center justify-center gap-3">
          <div
            className="flex h-11 w-11 items-center justify-center rounded-2xl text-white shadow-lg shadow-purple-950/40"
            style={{ background: "linear-gradient(135deg,#8b5cf6,#6d28d9)" }}
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 10V3L4 14h7v7l9-11h-7Z" />
            </svg>
          </div>
          <span className="text-lg font-bold tracking-wide text-white">SMS Agendador</span>
        </div>

        <div className="rounded-3xl bg-white/95 p-7 shadow-2xl shadow-purple-950/40 ring-1 ring-white/20 backdrop-blur-xl sm:p-9">
        <div className="mb-8">
          <p className="text-sm font-semibold text-violet-700">Configuração inicial</p>
          <h1 className="text-2xl font-bold text-slate-900">Primeiro administrador</h1>
          <p className="mt-2 text-sm text-slate-500">Use esta tela apenas no primeiro acesso do ambiente.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Nome</label>
            <input
              type="text"
              value={form.nome}
              onChange={(event) => setField("nome", event.target.value)}
              className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3 py-2.5 text-sm outline-none transition focus:border-transparent focus:bg-white focus:ring-2 focus:ring-violet-500"
              required
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Usuário</label>
            <input
              type="text"
              value={form.login}
              onChange={(event) => setField("login", event.target.value)}
              className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3 py-2.5 text-sm outline-none transition focus:border-transparent focus:bg-white focus:ring-2 focus:ring-violet-500"
              autoComplete="username"
              required
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">Senha</label>
            <input
              type="password"
              value={form.senha}
              onChange={(event) => setField("senha", event.target.value)}
              className="w-full rounded-xl border border-slate-200 bg-slate-50/50 px-3 py-2.5 text-sm outline-none transition focus:border-transparent focus:bg-white focus:ring-2 focus:ring-violet-500"
              autoComplete="new-password"
              minLength={6}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full rounded-xl px-4 py-3 text-sm font-semibold tracking-wide text-white shadow-lg shadow-purple-900/30 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-purple-900/50 active:translate-y-0"
            style={{ background: "linear-gradient(135deg,#7c3aed,#6d28d9)" }}
          >
            Criar administrador
          </button>
        </form>

        <div className="mt-6 flex justify-end">
          <Link to="/login" className="text-sm font-medium text-violet-600 transition hover:text-violet-800 hover:underline">
            Voltar ao login
          </Link>
        </div>
      </div>
      </div>
    </div>
  );
}
